import { doPost } from '#lib/network/helpers';

export const propertyManagementCopilot = {
  ask: (ticketId: string) => () => doPost<{ response: string }>(`/agents/property-management-copilot/ask/${ticketId}`)
};
